import Util from '@/helper/Utility.js';

export function CartItemModel() {
    this.actualPrice = null;
    this.name = null;
    this.nameEng = null;
    this.quantity = null;
    this.rowKey = null;
    this.cartInvalidErrorMessage = null;

    this.campaignId = null;
    this.parentCampaignId = null;
    this.sideCampaigns = [];

    this.remark = null;
    this.styleJson = null;


    this.priceItem = null;
    this.price2 = null;

    this.subscriptionName = null;
    this.subscriptionDetailName = null;
    this.info1 = null;

    this.originalPrice = null;

    this.setFromCartItemApi = (dict) => {
        let i;
        this.actualPrice = dict.ActualPrice;
        this.name = dict.Name;
        this.nameEng = dict.NameEng;
        this.quantity = dict.Quantity;
        this.rowKey = dict.RowKey;
        this.cartInvalidErrorMessage = dict.CartInvalidErrorMessage;

        this.campaignId = dict.CampaignId;
        this.parentCampaignId = dict.ParentCampaignId
        this.sideCampaigns = [];
        if (dict.SideCampaigns && dict.SideCampaigns instanceof Array) {
            if (dict.SideCampaigns.length > 0) {
                for (i = 0; i < dict.SideCampaigns.length; i++) {
                    this.sideCampaigns.push(new SideCampaignsModel(dict.SideCampaigns[i]));
                }
            }
        }

        if(!Util.isEmptyStr(dict.Remark)){
            this.remark = JSON.parse(dict.Remark)
        }
        if(!Util.isEmptyStr(dict.StyleJson)){
            this.styleJson = JSON.parse(dict.StyleJson)
        }

        this.priceItem = this.actualPrice;
        for (let campaign of this.sideCampaigns) {
            this.priceItem = this.priceItem + (campaign.pricePerUnit * campaign.quantity);
        }
        this.priceItem = this.priceItem * this.quantity;
        this.price2 = dict.Price2;

        this.subscriptionName = dict.SubscriptionName;
        this.subscriptionDetailName = dict.SubscriptionDetailName;
        this.info1 = dict.Info1;

        this.originalPrice = dict.OriginalPrice;
    }

    this.setFromPromotion = (dict) => {
        this.actualPrice = 0;
        this.name = dict.Name;
        this.nameEng = dict.NameEN;
        this.quantity = 1;
        this.rowKey = dict.Id;
        this.cartInvalidErrorMessage = null;

        this.campaignId = dict.Id;
        this.parentCampaignId = null;
        this.sideCampaigns = [];

        this.remark = null;
        this.styleJson = null;


        this.priceItem = 0;
        this.price2 = 0;
    }

    this.setQuantity = (quantity) => {
        this.quantity = quantity;
        this.priceItem = this.actualPrice;
        for (let campaign of this.sideCampaigns) {
            this.priceItem = this.priceItem + (campaign.pricePerUnit * campaign.quantity);
        }
        this.priceItem = this.priceItem * this.quantity;
        return this;
    };

    this.getPackagesForShipping = () => {
        var params = {
            name: this.name,
            description: '',
            quantity: this.quantity,
            price: this.price2
        }
        return Util.cleanObjectEmptyStr(params);
    }

    /**
     * Get parameter for api.
     */
    this.getParams = () => {
        var params = {
            id: this.rowKey,
            qty: this.quantity
        }
        return Util.cleanObjectEmptyStr(params);
    };
}
export function SideCampaignsModel(dict) {
    this.campaignId = dict.CampaignId;
    this.name = dict.Name;
    this.nameEng = dict.Name_EN;
    this.pricePerUnit = dict.PricePerUnit;
    this.quantity = dict.Quantity;
    this.type = dict.Type
}
